import { render, staticRenderFns } from "./NoticeLayer.vue?vue&type=template&id=7c33a741&"
import script from "./NoticeLayer.vue?vue&type=script&lang=js&"
export * from "./NoticeLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-web/cafe-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c33a741')) {
      api.createRecord('7c33a741', component.options)
    } else {
      api.reload('7c33a741', component.options)
    }
    module.hot.accept("./NoticeLayer.vue?vue&type=template&id=7c33a741&", function () {
      api.rerender('7c33a741', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/bbs-list/components/layer/NoticeLayer.vue"
export default component.exports